import { BinderMinimal, BinderSmall } from '@/models/binder.model';
import { CurrencyPipe, CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Plan } from 'src/app/models/plan.model';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-binder-badge',
    template: `
    <div class="flex relative">
      <div class="relative">
        <img [src]="getPlanThumb()" class="mr-2 h-[45px] border-round" style="border-radius: var(--border-radius);"/>
        @if (loading) {
          <div class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 rounded" style="border-radius: var(--border-radius);">
            <p-progressSpinner [style]="{'width': '20px', 'height': '20px'}" strokeWidth="3"></p-progressSpinner>
          </div>
        }
      </div>
      <div class="mr-0 md:mr-1 ml-1">
        <!-- <div class="block text-xl text-500 font-medium mb-1">{{ getPlanName() }}</div> -->
        <div class="block text-600 text-xl text-left font-bold mb-1">{{ binder?.ClientLastName || 'No ' + type + ' Selected' }}</div>
        <div class="block text-400 text-left">{{ (binder?.BinderTotal || 0 ) | currency }}</div>
      </div>
    </div>
  `,
  imports: [
    CommonModule,
    CurrencyPipe,
    ProgressSpinnerModule
  ],
  styles: [
    `
    .card {
      border: 1px solid #e9ecef;
    }
    `
  ]
})
export class BinderBadgeComponent {
  @Input() binder: BinderMinimal | BinderSmall | null = null;
  @Input() type: 'Binder' | 'Prelim' = 'Binder';
  @Input() loading: boolean = false;

  getPlanThumb(): string {
    if (this.binder) {
        return this.binder.Plans.Thumb || '/images/LexarIcon.png';
    }
    return '/images/LexarIcon.png';
  }

}